export default [
  {
    path: "/audit-policy-compliance-result-user",
    name: "AuditPolicyCompliance-Result-User",
    component: () =>
      import("@/views/Page/AuditPolicyCompliance/ComplianceResultAudit.vue"),
    meta: { title: "ComplianceResultAudit" },
  },
];
